// Routes owned by the Service module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const servicePaths = {
    services: '/services',
    serviceDetail: '/services/:id',
    serviceSLAConfig: '/services/:id/sla',
    serviceSLAReport: '/services/:id/sla/report',
    serviceSLADashboard: '/services/sla-dashboard',
    serviceCreateAddons: '/services/:id/addons/new',
    serviceConfigEdit: '/services/:id/config',
    // SLA template pages: Service's pages, mounted under /settings (Service/settings-routes.tsx).
    slaTemplates: '/settings/sla-templates',
    slaTemplateCreate: '/settings/sla-templates/create',
    slaTemplateEdit: '/settings/sla-templates/:id/edit',
} as const
